import { render } from "./QuestionAndAnswer.vue?vue&type=template&id=386599a7"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserGuide/QuestionAndAnswer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "386599a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('386599a7', __exports__)) {
    api.reload('386599a7', __exports__)
  }
  
  module.hot.accept("./QuestionAndAnswer.vue?vue&type=template&id=386599a7", () => {
    api.rerender('386599a7', render)
  })

}


export default __exports__